import { render, staticRenderFns } from "./EcosystemNeed.vue?vue&type=template&id=6cea6fe6&scoped=true&"
import script from "./EcosystemNeed.vue?vue&type=script&setup=true&lang=js&"
export * from "./EcosystemNeed.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cea6fe6",
  null
  
)

export default component.exports